import { Box, Typography } from "@mui/material";
import { INTAKE_COLORS, INTAKE_FONT } from "../../theme/intakeTokens";

function sevClass(sev) {
  if (sev === "CRITICAL") return { bg: INTAKE_COLORS.redLight, color: INTAKE_COLORS.red };
  if (sev === "HIGH") return { bg: INTAKE_COLORS.amberLight, color: INTAKE_COLORS.amber };
  if (sev === "MEDIUM") return { bg: INTAKE_COLORS.blueLight, color: INTAKE_COLORS.blueDark };
  return { bg: INTAKE_COLORS.greenLight, color: INTAKE_COLORS.greenDark };
}

export default function OutputCard({ outputs }) {
  const risks = outputs?.risks || [];
  if (!risks.length) return null;

  return (
    <Box sx={{ mt: 1.25 }}>
      <Typography sx={{ fontWeight: 700, fontSize: 13, mb: 1 }}>
        ✓ Outputs generated — ready for Gate 1
      </Typography>
      <Box
        sx={{
          background: `linear-gradient(135deg, ${INTAKE_COLORS.purpleLight}, ${INTAKE_COLORS.blueLight})`,
          border: "1px solid rgba(124,58,237,.2)",
          borderRadius: "10px",
          p: 1.5,
          fontFamily: INTAKE_FONT,
        }}
      >
        <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 1 }}>Seed Risk Register — {risks.length} risks</Typography>
        {risks.slice(0, 5).map((r, idx) => {
          const sev = sevClass(r.severity);
          return (
            <Box key={r.id || idx} sx={{ display: "flex", gap: 1, py: 0.625, borderBottom: "1px solid rgba(0,0,0,.06)" }}>
              <Typography sx={{ fontSize: 9, fontWeight: 700, px: 0.75, py: 0.25, borderRadius: "3px", bgcolor: sev.bg, color: sev.color, flexShrink: 0 }}>
                {r.severity}
              </Typography>
              <Typography sx={{ fontSize: 11, lineHeight: 1.4 }}>
                {r.description || ""}
                {r.category ? (
                  <Box component="span" sx={{ color: INTAKE_COLORS.g4, fontSize: 10 }}> — {r.category}</Box>
                ) : null}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
